import React from "react";
import "./pageTitle.css";

export const PageTitle = ({ title, buttonGroup, goBack }) => {
	return (
		<div className="d-flex align-items-center justify-content-between page_title_custom">
			{goBack && (
				<div className="d-flex align-items-center m-2">{goBack}</div>
			)}

			<h4 className="m-0">{title}</h4>
			<div className="d-flex">{buttonGroup ? buttonGroup : null}</div>
		</div>
	);
};
